/** Maps app permission keys to API permission strings. */
export const PERMISSION = {
  CONFIGURATOR_VIEW_GROUP_DASHBOARD: "CONFIGURATOR.VIEW.GROUP.DASHBOARD",
  CONFIGURATOR_CATEGORY_CREATE: "CONFIGURATOR.CATEGORY.CREATE",
  CONFIGURATOR_PRODUCT_CREATE: "CONFIGURATOR.PRODUCT.CREATE",
};
